import { render, staticRenderFns } from "./SupChangeAudit.vue?vue&type=template&id=5891bb6d&scoped=true&"
import script from "./SupChangeAudit.vue?vue&type=script&lang=js&"
export * from "./SupChangeAudit.vue?vue&type=script&lang=js&"
import style0 from "./SupChangeAudit.vue?vue&type=style&index=0&id=5891bb6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5891bb6d",
  null
  
)

export default component.exports